const ID_SEGMENT = /^\d+$/;
const UUID_SEGMENT =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const stripLeadingSlash = (pathname: string): string =>
  pathname.replace(/^\//, '') || 'login';

// The session timeline groups events by this key, so it has to stay stable
// across records: `home/property/847/report` and `home/property/848/report`
// are the same screen and must collapse into a single accordion.
export const toRouteGroup = (route: string): string =>
  route
    .split('/')
    .map((segment) =>
      ID_SEGMENT.test(segment) || UUID_SEGMENT.test(segment) ? '{id}' : segment
    )
    .join('/');

let currentRoute = stripLeadingSlash(window.location.pathname);
let currentRouteGroup = toRouteGroup(currentRoute);

export const setCurrentRoute = (route: string): void => {
  currentRoute = route;
  currentRouteGroup = toRouteGroup(route);
};

export const getCurrentRoute = (): string => currentRoute;

export const getCurrentRouteGroup = (): string => currentRouteGroup;
